import { useEffect, useState } from 'react';
import { RouteMetadata } from '@/components/seo/RouteMetadata';

export const TermsOfUseRoute = () => {
  const [htmlContent, setHtmlContent] = useState<string>('');

  useEffect(() => {
    // Fetch the terms of use HTML file
    fetch('/terms-of-use.html')
      .then(response => response.text())
      .then(html => setHtmlContent(html))
      .catch(error => {
        console.error('Error loading terms of use:', error);
        setHtmlContent('<div class="p-8"><h1>Terms of Use</h1><p>Error loading terms of use content.</p></div>');
      });
  }, []);

  return (
    <>
      <RouteMetadata
        title="Terms of Use - Uavity"
        description="Read our terms of use to understand the rules and guidelines for using our services."
        keywords="terms of use, legal terms, user agreement, service terms, terms and conditions"
        tags={['legal', 'terms', 'agreement', 'user terms']}
      />
      <div className="min-h-screen bg-background">
        <div className="container mx-auto px-4 py-8">
          <div 
            className="prose prose-slate dark:prose-invert max-w-none"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        </div>
      </div>
    </>
  );
};
